/* src/app/reports/grafana-support-dashboards/grafana-support-dashboards.component.css */
:host {
  display: block;
}
/*# sourceMappingURL=grafana-support-dashboards.component.css.map */
